import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Create React root
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App with ThemeProvider and AuthProvider
root.render(
  <App />
);
